/**
 * List Controller
 */
(function(angular) {
    'use strict';

    let app = angular.module('asSupplyMgr');

    app.controller('InventoryClusterController', [
        '$scope',
        '$timeout',
        'clusterApi',
        function($scope, $timeout, clusterApi) {
            $scope.loading = false;

            $scope.list = null;
            $scope.createMessage = null;
            $scope.createDisabled = false;
            // $scope.page = {
            //     number: 0,
            //     size: 500,
            // };
            //
            // $scope.searchTerm = '';
            //
            // $scope.sort = {
            //     field: 'name',
            //     order: 'asc',
            // };

            /**
             * Fetch list data from server
             */
            $scope.fetch = function() {
                $scope.loading = true;
                clusterApi.getList().then(
                    function(data) {
                        $scope.list = {
                            count: data.count,
                            data: data.data,
                        };
                        $scope.loading = false;
                    },
                    function() {
                        $scope.list = {
                            count: 0,
                            data: [],
                        };
                        $scope.loading = false;
                    }
                );
            };

            // try saving and process server side validation errors
            $scope.submitForm = function() {
                $scope.disableButtons(800);
                clusterApi.create($scope.inventory_cluster).then(
                    function(message) {
                        $scope.error = false;
                        $scope.createMessage = message;
                        $scope.fetch();
                    },
                    function(message) {
                        $scope.error = true;
                        $scope.createMessage = message;
                        $scope.createDisabled = false;
                    }
                );
            };

            $scope.disableButtons = function(msec){
                $scope.createDisabled = true;
                $timeout( function(){
                    $scope.createDisabled = false;
                }, msec );
            };

            // show the delete confirmation dialog
            $scope.promptDelete = function(cluster) {
                $scope.clusterToDelete = cluster;
                $('#delete-modal').modal('show');
            };

            $scope.delete = function(cluster) {
                clusterApi.delete(cluster._id).then(function() {
                    $scope.fetch();
                });
            };

            $scope.fetch();
        },
    ]);
})(window.angular);
